import { api, apiDefault } from "@/library/http";
import store from "@/store";

const cartContext = store.getters['cartContext/cartContext'];
const { currency, language, ...orderData } = cartContext;

export const registration = (authParams) => api.post('/auth/register', { cart_context: cartContext, auth: authParams });

export const login = (authParams) => api.post('/auth/login', { cart_context: cartContext, auth: authParams });

export const updateClient = (authParams, cookie) => api.patch('/auth/update-client-for-trial', authParams, { headers: { Authorization: cookie }} );

export const sendSms = (phonenumber) => api.post('/auth/sendsms', { cart_context: cartContext, phonenumber });

export const verifySmsCode = (phonenumber, code) => api.post('/auth/verifysmscode', { phonenumber, code });

export const verifyEmail = (email) => api.post('/auth/check-email/', { email });

export const getGeoip = () => apiDefault.get('/geoip/');

export const cartOrder = (authParams, cookie, paymentData, verifyHash) => (api.post(`/cart/order`, { ...orderData, ...paymentData, promo: cartContext.promo }, { headers: { Authorization: cookie, Verifyhash:  verifyHash }}));
